import {Box, useMantineTheme} from '@mantine/core';
import React, {useMemo} from 'react';

import {ProcessFlowchartValidationError} from 'processes/graph-builder-processes/validation/ProcessFlowchartForValidationTypes';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {STATUS_COLORS} from 'ui-library/reactflow/nodes/BenchlingNode/v2/BenchlingNodeV2Constants';

function aggregateNodeErrors(
  nodeErrors: Array<ProcessFlowchartValidationError>
): Array<{errorMessage: string; count: number}> {
  const counts = new Map<string, number>();
  for (const error of nodeErrors) {
    counts.set(error.errorMessage, (counts.get(error.errorMessage) ?? 0) + 1);
  }
  return Array.from(counts.entries()).map(([errorMessage, count]) => ({errorMessage, count}));
}

export function NodeErrorStatusTooltipContent({
  nodeErrors,
}: {
  nodeErrors: Array<ProcessFlowchartValidationError>;
}): JSX.Element {
  const theme = useMantineTheme();
  const errorColor = theme.colors[STATUS_COLORS.error.color][STATUS_COLORS.error.colorIndex];
  const aggregatedErrors = useMemo(() => aggregateNodeErrors(nodeErrors), [nodeErrors]);
  return (
    <Box>
      {aggregatedErrors.map(({errorMessage, count}, index) => (
        <Box
          key={errorMessage}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            marginBottom: index < aggregatedErrors.length - 1 ? '8px' : 0,
          }}
        >
          <BenchlingIcon icon="circle-xmark" style={{color: errorColor, height: 16, width: 16}} />
          {errorMessage}
          {count > 1 && (
            <Box component="span" sx={{fontWeight: 600}}>
              {` x${count}`}
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
}
